import {gql} from '@apollo/client';
export const DOWNLOAD_DESIGN = gql`
    mutation downloadDesign($designId: ID!){
        downloadDesign(designId: $designId)
    }
`

export const DOWNLOAD_DESIGN_V2 = gql`
mutation downloadDesignV2($designId: ID!){
    downloadDesignV2(designId: $designId)
}
` 